export default __webpack_public_path__ + "static/media/clarin.da690c1a.svg";